import { useTheme } from '@mui/material';

import { getNumber } from '~/utils/helpers/number';

import {
  CUSTOM_HOLIDAY_PURPLE,
  CUSTOM_PADDING,
  DAY_GRAY,
  HOLIDAY_GREEN,
  MATERNITY_LEAVE_BLUE,
  MILITARY_REHEARSAL_BROWN,
  OTHER,
  PUBLIC_HOLIDAY,
  SICK_LEAVE_RED,
  STUDY_LEAVE_YELLOW,
} from '../../constants';

export const useSxStyles = () => {
  const theme = useTheme();

  return {
    main: {
      width: '25px',
      height: '25px',
      borderRadius: `${getNumber(theme.shape.borderRadius) + 1}px`,
      display: 'inline-block',
      textAlign: 'center',
      fontWeight: theme.typography.fontWeightBold ?? 'fontWeightBold',
      padding: `${CUSTOM_PADDING}px`,
    },
    holiday: {
      backgroundColor: HOLIDAY_GREEN,
    },
    militaryLeave: {
      backgroundColor: MILITARY_REHEARSAL_BROWN,
    },
    sickLeave: {
      backgroundColor: SICK_LEAVE_RED,
    },
    maternityLeave: {
      backgroundColor: MATERNITY_LEAVE_BLUE,
    },
    study: {
      backgroundColor: STUDY_LEAVE_YELLOW,
    },
    customHoliday: {
      backgroundColor: CUSTOM_HOLIDAY_PURPLE,
    },
    publicHoliday: {
      backgroundColor: PUBLIC_HOLIDAY,
      color: 'white',
    },
    other: {
      backgroundColor: OTHER,
    },
    empty: {
      backgroundColor: DAY_GRAY,
    },
    divWrapper: {
      display: 'flex',
      padding: theme.spacing(0.5),
    },
    absenceLabel: {
      paddingLeft: theme.spacing(0.5),
      paddingTop: theme.spacing(0.3),
      textTransform: 'Capitalize',
    },
    contentWrapper: {
      display: 'flex',
      flexWrap: 'wrap',
      justifyContent: 'space-between',
    },
    columnWrapper: {
      width: '50%',
    },
  };
};
